import moment from "moment";
import Vue from "vue";
import { router } from "@/router";
import ReportsService from "@/services/ReportsService";
import _ from "lodash";
import store from "@/store";

function initialState() {
  return {
    AdvanceBookingReportsExcelFileName: null,
    AdvanceBookingReportsPDFFileName: null,
    dropDownObject: {
      fromDate: moment().toDate(),
      cinema_name: null,
      cinema_id: null,
      currentPage: 1,
      limit: 10,
      cinema_address:null,
    },
    rows: 0,
    perPage: 10,
    selectedvalue: "10",
    AdvanceBookingReportData: [],
  };
}

const state = initialState();

const mutations = {
  SET_ADVANCE_BOOKIING_EXCEL_FILE_NAME: (state, payload) => {
    state.AdvanceBookingReportsExcelFileName = payload;
  },
  SET_ADVANCE_BOOKIING_PDF_FILE_NAME: (state, payload) => {
    state.AdvanceBookingReportsPDFFileName = payload;
  },
  SET_DROP_DOWN_VALUES: (state, payload) => {
    switch (payload.name) {
      case "isCinema":
        state.dropDownObject.cinema_id = payload["selectedItem"]
          ? payload.selectedItem.cine_id
          : null;
        state.dropDownObject.cinema_name = payload["selectedItem"]
          ? payload.selectedItem.cine_name
          : null;
          state.dropDownObject.cinema_address = payload["selectedItem"]
          ? payload.selectedItem.cine_address
          : null;
        break;
      case "fromDate":
        state.dropDownObject.fromDate = payload["event"]
          ? payload["event"]
          : new Date();
        break;
      case "currentPage":
        console.log({ paylod: payload.currentPage });
        state.dropDownObject.currentPage = payload["currentPage"]
          ? payload["currentPage"]
          : 1;
      case "limit":
        console.log({ payload: payload.limit });
        state.dropDownObject.limit = payload["limit"]
          ? payload["limit"]
          : state.dropDownObject.limit;
      default:
        console.log(
          "Advance Booking Report :( Sorry, we are enable to set value."
        );
    }
  },
  SET_ADVANCE_BOOKIING_REPORT: (state, payload) => {
    state.AdvanceBookingReportData = payload || [];
  },
  SET_LIMIT: (state, payload) => {
    state.dropDownObject.limit = payload || 10;
  },
  SET_TOTAL_ROWS: (state, payload) => {
    state.rows = payload || 10;
  },
  SET_CURRENT_PAGE: (state, payload) => {
    state.dropDownObject.currentPage = payload || 1;
  },
  SET_SELECTED_VALUE: (state, payload) => {
    state.selectedvalue = payload || "10";
  },
  SET_PER_PAGE: (state, payload) => {
    state.perPage = payload || 10;
  },
};

const actions = {
  updateLimit: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_LIMIT", payload);
  },
  updatePerPage: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_PER_PAGE", payload);
  },
  updateSelectedValue: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_SELECTED_VALUE", payload);
  },
  onAdvanceBookingReportDropDownHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onFetchAdvanceBookingReport: async ({ dispatch, commit, state }, payload={}) => {
    await commit("SET_ADVANCE_BOOKIING_REPORT", []);
    let loader = Vue.$loading.show();
    if (!state.dropDownObject["fromDate"]) {
      loader.hide();
      return Vue.toasted.show("Select date");
    }
    state.dropDownObject["fromDate"] = moment(
      state.dropDownObject["fromDate"]
    ).format("YYYY-MM-DD");
    await ReportsService.GetAdvanceBookingReport({...state.dropDownObject,...payload})
      .then(async (response) => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_ADVANCE_BOOKIING_REPORT", data.Records);
          if (data.totalRows && data.totalRows >= 10) {
            commit("SET_TOTAL_ROWS", data.totalRows);
            commit("SET_SELECTED_VALUE", state.perPage);
            this.selectedvalue = this.perPage;
          } else if (data.totalRows) {
            commit("SET_TOTAL_ROWS", data.totalRows);
            commit("SET_SELECTED_VALUE", data.totalRows);
            this.selectedvalue = data.totalRows;
          } else if (data.Records && data.Records.length == 0) {
            commit("SET_TOTAL_ROWS", 0);
            commit("SET_SELECTED_VALUE", 0);
            this.$toasted.show("No Records Found.");
          } else {
            commit("SET_TOTAL_ROWS", 0);
            commit("SET_SELECTED_VALUE", 0);
            this.$toasted.show(data.message);
          }
          await commit(
            "SET_ADVANCE_BOOKIING_EXCEL_FILE_NAME",
            data["ExcelName"] || null
          );
          await commit(
            "SET_ADVANCE_BOOKIING_PDF_FILE_NAME",
            data["PDFName"] || null
          );
          loader.hide();
        } else {
          Vue.toasted.show(data.message || "No records found");
          loader.hide();
        }
      })
      .catch((error) => {
        Vue.toasted.show("Catch Error on Municipalty Reports", error);
      })
      .finally(() => {
        setTimeout(() => loader.hide(), 1000);
      });
  },
};

const getters = {
  getAdvanceBookingReportSelectedCinema: (state) =>
    state.dropDownObject.cinema_name,
  getAdvanceBookingReportLimit: (state) => state.dropDownObject.limit,
  getAdvanceBookingReportcurrentPage: (state) =>
    state.dropDownObject.currentPage,
  getAdvanceBookingReportFromDate: (state) => state.dropDownObject.fromDate,
  getAdvanceBookingReportTotalRows: (state) => state.rows,
  getAdvanceBookingReportselectedValue: (state) => state.selectedvalue,
  getAdvanceBookingReportperPage: (state) => state.perPage,
  getAdvanceBookingReportData: (state) => state.AdvanceBookingReportData,

  getAdvanceBookingReportsExcelFileName: (state) =>
    state.AdvanceBookingReportsExcelFileName,
  getAdvanceBookingReportsPDFFileName: (state) =>
    state.AdvanceBookingReportsPDFFileName,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/AdvanceBookingReport.js